﻿/**
 * app.routes
 * @namespace portal
 */

(function () {
	'use strict';

	/** configure the nha.curriculum module */
	angular.module('nha.portal').config(config);

	/** setup injection */
	config.$inject = ['$stateProvider', 'appSettings'];

	/** implementation */
	function config($stateProvider, appSettings) {
		/** setup parent route */
		$stateProvider.state('portal', {
			abstract: true,
			url: '',
			template: '<portal />',
			ncyBreadcrumb: {
				skip: true
			}
		});

		/** setup main route */
		$stateProvider.state('portal.main', {
			url: '/',
			template: '<portal-main />',
			ncyBreadcrumb: {
				label: 'Home'
			},
			resolve: {
				authorization: ['stateTransitionSecurityCheck', function (stateTransitionSecurityCheck) {
					return stateTransitionSecurityCheck.resolveAuthorization('ui_portal_main', 'Portal');
				}]
			},
			data: {
				security: {
					requiredResource: 'ui_portal_main',
					api: 'Portal'
				}
			}
		});

		/** setup admin routes */
		$stateProvider.state('portal.admin', {
			abstract: true,
			url: '/admin',
			template: '<portal-admin />',
			ncyBreadcrumb: {
				label: 'Admin'
			},
			resolve: {
				authorization: ['stateTransitionSecurityCheck', function (stateTransitionSecurityCheck) {
					return stateTransitionSecurityCheck.resolveAuthorization('ui_portal_admin', 'Portal');
				}]
			},
			data: {
				security: {
					requiredResource: 'ui_portal_admin',
					api: 'Portal'
				}
			}
		}).state('portal.admin.portal-links', {
			url: '/links',
			template: '<portal-admin-links />',
			ncyBreadcrumb: {
				label: 'Portal Links',
				parent: 'portal.admin'
			}
		}).state('portal.admin.portal-groups', {
			url: '/groups',
			template: '<portal-admin-groups />',
			ncyBreadcrumb: {
				label: 'Portal Groups',
				parent: 'portal.admin'
			},
			resolve: {
				authorization: ['stateTransitionSecurityCheck', function (stateTransitionSecurityCheck) {
					return stateTransitionSecurityCheck.resolveAuthorization('ui_portal_editor', 'Portal');
				}]
			},
			data: {
				security: {
					requiredResource: 'ui_portal_editor',
					api: 'Portal'
				}
			}
		}).state('portal.admin.portal-quicklinks', {
			url: '/quicklinks',
			template: '<portal-admin-quicklinks />',
			ncyBreadcrumb: {
				label: 'Portal Quick Links',
				parent: 'portal.admin'
			},
			resolve: {
				authorization: ['stateTransitionSecurityCheck', function (stateTransitionSecurityCheck) {
					return stateTransitionSecurityCheck.resolveAuthorization('ui_portal_editor', 'Portal');
				}]
			},
			data: {
				security: {
					requiredResource: 'ui_portal_editor',
					api: 'Portal'
				}
			}
		}).state('portal.admin.portal-settings', {
			url: '/settings',
			template: '<portal-admin-settings />',
			ncyBreadcrumb: {
				label: 'Portal Settings',
				parent: 'portal.admin'
			},
			resolve: {
				authorization: ['stateTransitionSecurityCheck', function (stateTransitionSecurityCheck) {
					return stateTransitionSecurityCheck.resolveAuthorization('ui_portal_editor', 'Portal');
				}]
			},
			data: {
				security: {
					requiredResource: 'ui_portal_editor',
					api: 'Portal'
				}
			}
		});

		/** setup forbidden route */
		$stateProvider.state('portal.403', {
			url: '/403',
			templateUrl: appSettings.coreWebRootUrl + 'app/templates/403.html',
			ncyBreadcrumb: {
				label: 'No Access',
				parent: 'portal'
			},
			title: 'No Access'
		});
	}
})();